module.exports = __webpack_public_path__ + "static/media/svg-8.4d09ff33.svg";